var _circle, _path, _path2, _path3, _circle2, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseAdminTabActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 41 40",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "url(#course-admin-tab-active_svg__paint0_linear_574_12743)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 27.75L21.5 40c9.625-.625 17.5-7.5 19-18l-11-11-19.25 16.75z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.625 10.625h-17.5c-.688 0-1.25.563-1.25 1.25v15c0 .688.563 1.25 1.25 1.25h17.5c.688 0 1.25-.563 1.25-1.25v-15c0-.688-.563-1.25-1.25-1.25z",
    fill: "#FFFCF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#344E5F",
    d: "M9.875 13.125h20v1.25h-20z",
    opacity: 0.149
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.125,
    cy: 11.875,
    r: 0.625,
    fill: "#F3643F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 11.25c-.375 0-.625.25-.625.625s.25.625.625.625.625-.25.625-.625-.25-.625-.625-.625zm10.625 4.375v7.5h5v-7.5h-5z",
    fill: "#EDC03D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.875 12.5c.375 0 .625-.25.625-.625s-.25-.625-.625-.625-.625.25-.625.625.25.625.625.625zm-3.75 3.125v11.25h11.25v-11.25h-11.25z",
    fill: "#3DBB69"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "course-admin-tab-active_svg__paint0_linear_574_12743",
    x1: 0.5,
    y1: 40,
    x2: 40.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7D8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03A569"
  })))));
}
export default __webpack_public_path__ + "fonts/course-admin-tab-active-be1f1fad114df89345d00f9adda39227.svg";
export { SvgCourseAdminTabActive as ReactComponent };